import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';

import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { NbRoleProvider, NbAclService, NbAccessControl } from '@nebular/security';

@Injectable()
export class RoleProvider implements NbRoleProvider {

  constructor(private authService: NbAuthService,    public acl:NbAclService) {
  }

  permissions: NbAccessControl={};
  getRole(): Observable<string> {
    
    return this.authService.onTokenChange()
      .pipe(
        map((token: NbAuthJWTToken) => {
          var user=JSON.parse(localStorage.getItem("USER_LOGGED"));

          this.permissions= JSON.parse(user.Permission);
          this.acl.setAccessControl(this.permissions);
        

          return user.Role;
           
        }),
      );
  }
}